import { dispatchPWAEvent, PWA_OFFLINE_READY, PWA_UPDATE_AVAILABLE } from './pwa-events';

/** @type {ServiceWorkerRegistration | null} */
let _registration = null;

/**
 * @returns {ServiceWorkerRegistration | null}
 */
export function getServiceWorkerRegistration() {
  return _registration;
}

/**
 * @param {ServiceWorkerRegistration} registration
 */
function watchInstallingWorker(registration) {
  const newWorker = registration.installing;
  if (!newWorker) return;

  newWorker.addEventListener('statechange', () => {
    if (newWorker.state !== 'installed') return;
    if (navigator.serviceWorker.controller) {

      dispatchPWAEvent(PWA_UPDATE_AVAILABLE, { registration });
    } else {

      dispatchPWAEvent(PWA_OFFLINE_READY, { registration });
    }
  });
}

/**
 * Registra il service worker e notifica update / offline-ready (no reload automatico).
 * @returns {Promise<ServiceWorkerRegistration | null>}
 */
export async function registerAppServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }

  const isProductionBuild = process.env.NODE_ENV === 'production';
  const enableSwInDev = process.env.REACT_APP_ENABLE_SW === 'true';
  if (!isProductionBuild && !enableSwInDev) {
    return null;
  }

  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const swUrl = `${publicUrl}/service-worker.js`;
  const registration = await navigator.serviceWorker.register(swUrl);
  _registration = registration;



  registration.addEventListener('updatefound', () => {
    watchInstallingWorker(registration);
  });

  const installing = registration.installing;
  if (installing) {
    installing.addEventListener('statechange', () => {
      if (installing.state === 'installed' && !navigator.serviceWorker.controller) {
        installing.postMessage({ type: 'SKIP_WAITING' });
      }
    });
  }

  if (registration.waiting && navigator.serviceWorker.controller) {
    dispatchPWAEvent(PWA_UPDATE_AVAILABLE, { registration });
  } else if (registration.waiting && !navigator.serviceWorker.controller) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }

  if (isProductionBuild) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }

  return registration;
}

/**
 * Controlla aggiornamenti SW (es. tab tornata visibile).
 * @returns {Promise<void>}
 */
export async function checkForServiceWorkerUpdate() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const registration = _registration ?? (await navigator.serviceWorker.ready);
    await registration.update();
    if (registration.waiting && navigator.serviceWorker.controller) {
      dispatchPWAEvent(PWA_UPDATE_AVAILABLE, { registration });
    }
  } catch (err) {

  }
}

/**
 * Attiva il worker in waiting e ricarica (dopo controllerchange).
 * @param {ServiceWorkerRegistration | null | undefined} registration
 */
export function activateWaitingServiceWorker(registration) {
  const waiting = registration?.waiting;
  if (!waiting) {

    return;
  }
  waiting.postMessage({ type: 'SKIP_WAITING' });
}